import React, { Component, Fragment } from 'react';
import { Query } from '../../reactApolloCompat';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import * as moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import TextField from '../../components/form/TextField';
import Checkbox from '../../components/form/Checkbox';
import ColumnLayout from '../../components/layout/ColumnLayout';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import Button from '../../components/form/Button';
import Select from '../../components/form/Select';
import EnquiryFragment from '../../fragments/Enquiry';
import Table, { Cell, HeaderRow, Row } from '../../components/table/Table';
import Label from '../../components/form/Label';
import TickIcon from '../../components/icon/TickIcon';
import Spinner from '../../components/loading/Spinner';
import {
    copyFuneral,
    createCremationAsync,
    createPlaqueAsync,
    CurrentSituation,
    DeathTimingOption,
    DeathTimingOptions,
    EnquiryType,
    GenderOptions,
    readEnquiryQuotes,
    RelationshipToDeceasedOptions,
    TitleOptions
} from './EnquiryConstants';
import { LEAD_SOURCES } from '../../constants/Lead';
import AddressAutocomplete, { createAddressComponentFields } from '../../components/form/AddressAutocomplete';
import ViewHeader from '../../components/header/ViewHeader';
import Separator from '../../components/layout/Separator';
import NotesReadOnly from '../../components/form/NotesReadOnly';
import QuoteModal from './Modals/Quotation/QuoteModal';
import AppointmentModal from '../../components/modal/AppointmentModal';
import AshLocationHistoryModal from '../../components/modal/AshLocationHistoryModal';
import { joinDefined, PAGE_CREMATIONS, PAGE_PLAQUES, prettyPrice } from '../../utils/strings';
import ContactLookup from '../../components/contact/ContactLookup';
import ContactCard from '../../components/contact/ContactCard';
import { isContactDefined } from '../../utils/bookable';
import DeleteIcon from '../../components/icon/DeleteIcon';
import SearchIcon from '../../components/icon/SearchIcon';
import EditIcon from '../../components/icon/EditIcon';
import { deleteTypeName, isNullOrUndefined } from '../../utils/objects';
import { getUser } from '../../utils/sessions';
import { assembleReasonFromEnquiry } from '../Calendar/AppointmentPopover';
import AlertBar from '../../components/form/AlertBar';
import AssociatedOrders from '../../components/AssociatedOrders';
import FuneralSearchModal from './Modals/FuneralSearchModal';
import RecordDrawer from '../../components/workQueue/RecordDrawer';
import AutoComplete from '../../components/form/AutoComplete';
import { PlaqueSignIcon, UrnIcon } from '../../components/IconIndex';
import Dispatch from '../../components/modal/Dispatch';
import { appointmentColumns } from '../../utils/appointments';
import Pickup, { PickupOrDeliveryField } from '../../components/pickup/Pickup';

class Enquiry extends Component {
    state = {
        openSearchModal: false,
        searchModalSuggestion: null,
        showAppointmentModal: false,
        appointmentId: null,
        quoteModal: {
            open: false,
            quoteIndex: null
        },
        editAshLocationHistoryIndex: null,
        showAshLocationHistoryModal: false,
        generatingRelatedRecord: false,
        generatedRelatedRecord: null
    };
    refetchQuotes = null;

    render() {
        const {
            showAppointmentModal,
            appointmentId,
            quoteModal,
            showAshLocationHistoryModal,
            editAshLocationHistoryIndex,
            openSearchModal,
            searchModalSuggestion
        } = this.state;
        const { form } = this.props;

        let editAshLocationHistory = {
            ID: null,
            Location: '',
            LocationDetail: '',
            Notes: '',
            Changes: []
        };

        if (editAshLocationHistoryIndex !== null && editAshLocationHistoryIndex !== undefined) {
            editAshLocationHistory = form.getState('AshLocations')[editAshLocationHistoryIndex];
        }

        return (
            <Grid container>
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid item>{this.renderEnquiryDetails()}</Grid>

                        <Grid item>
                            <Separator />
                        </Grid>

                        <ColumnLayout>
                            {this.renderLeftColumn()}
                            {this.renderRightColumn()}
                        </ColumnLayout>

                        <AppointmentModal
                            open={!!showAppointmentModal}
                            parentForm={form}
                            appointmentId={appointmentId || null}
                            appointmentDefaults={
                                appointmentId
                                    ? null
                                    : {
                                        EnquiryCM: {
                                            ID: form.getField('ID'),
                                            LegacyKey: form.getField('LegacyKey')
                                        },
                                        ...assembleReasonFromEnquiry(form.state, { Type: 'Appointment' })
                                    }
                            }
                            memberList={[getUser()]}
                            onClose={() => this.handleCloseAppointmentModal()}
                            onMutate={appointment => this.onAfterAppointmentAddOrUpdate(appointment)}
                        />
                    </Paper>
                </Grid>

                <FuneralSearchModal
                    open={openSearchModal}
                    initialSearchTerm={searchModalSuggestion}
                    onAccept={e => this.copyDetailsFromFuneral(e, form)}
                    onClose={e => this.setState({ openSearchModal: false, searchModalSuggestion: null })}
                />

                <QuoteModal
                    open={quoteModal.open}
                    quoteIndex={quoteModal.quoteIndex}
                    onClose={refetch => this.handleCloseQuoteModal(refetch)}
                    parentForm={form}
                />

                <AshLocationHistoryModal
                    open={showAshLocationHistoryModal}
                    onClose={() => this.handleCloseAshLocationHistoryModal()}
                    onCancel={() => this.handleCloseAshLocationHistoryModal()}
                    onSubmit={ashLocationHistory => this.handleSaveAshLocationHistoryModal(ashLocationHistory)}
                    ashLocationHistory={editAshLocationHistory}
                    name="editAshLocationHistory"
                />
            </Grid>
        );
    }

    onAfterAppointmentAddOrUpdate(appointment) {
        const { form } = this.props;
        const Appointments = form.getField('Appointments');
        const foundIndex = Appointments.findIndex(e => e.ID === appointment.ID);
        if (foundIndex >= 0) {
            Object.assign(Appointments[foundIndex], appointment);
        } else {
            Appointments.push(appointment);
        }
        form.setField({ Appointments }, true);
    }

    renderHeader() {
        const { itemId, form } = this.props;
        const enquiryID = form.getField('LegacyKey');
        const enquiryType = form.getField('EnquiryType');

        const title = (itemId && itemId > 0 ? '' : 'New ') + (enquiryType ? enquiryType : '') + ' Booking';
        let subtitle = '';
        if (enquiryID) {
            subtitle =
                itemId && itemId > 0
                    ? <><strong>{enquiryID}</strong> {joinDefined(
                        [
                            form.getField('Deceased.FirstName'),
                            form.getField('Deceased.MiddleName'),
                            form.getField('Deceased.Surname')
                        ],
                        ' '
                    )}</>
                    : '';
        }

        return (
            <ViewHeader title={title} subtitle={subtitle}>
                <RecordDrawer enquiryCMId={itemId} legacyKey={enquiryID} />
            </ViewHeader>
        );
    }

    renderEnquiryDetails() {
        const { form, validationBadges } = this.props;
        let userName = '';
        if (form.getField('CreatedBy')) {
            userName += (form.getField('CreatedBy').FirstName || '') + ' ' + (form.getField('CreatedBy').Surname || '');
            userName = userName.trim();
        }
        if (!userName) userName = form.getField('CreatedBy') && form.getField('CreatedBy').Email;
        if (!userName) userName = '(unknown)';

        return (
            <Inline className="enquiry-header" alignment={inlineAlignment.rightAlignSiblings} center>
                <div style={{ display: 'flex' }}>
                    <div className="sort-by-container">
                        <Label className="label brand">Type</Label>
                        <Select
                            required
                            name="EnquiryType"
                            placeholder="Select a type of Booking"
                            options={EnquiryType}
                            form={form}
                        />
                    </div>
                    {<div className="tabs" style={{ margin: '1rem' }}>{!!validationBadges && validationBadges()}</div>}
                </div>
                <Inline center>
                    <p style={{ margin: '1rem', textAlign: 'right' }}>
                        <strong>Date Created: </strong>
                        <span className="regular">{' ' + moment(form.getField('Created')).format('Do MMMM Y')}</span>
                        <br />
                        <strong>By: </strong>
                        <span className="regular">{userName}</span>
                    </p>
                </Inline>
            </Inline>
        );
    }

    renderLeftColumn() {
        const { form } = this.props;
        const enquiryByBusiness = !!form.getField('EnquiryByBusiness');
        return (
            <Fragment>
                {this.renderEnquiryMadeBy()}
                {!enquiryByBusiness && (
                    <Grid bucket>
                        <Grid item xs={12}>
                            <Label>How did they hear about us?</Label>
                        </Grid>
                        {this.renderLeadSource()}
                    </Grid>
                )}
                {this.renderAuthorisedContact()}
                {this.renderRequestedOnBehalfOf()}
            </Fragment>
        );
    }

    handleSelectBusinessContact(propertyName, addressBook) {
        const { form } = this.props;
        delete addressBook['__typename'];

        if (!!addressBook) {
            form.setState({ [propertyName]: addressBook });
        }
    }

    renderEnquiryMadeBy() {
        const { form } = this.props;
        const businessContact = form.getField('Business');

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Enquirer Details</h4>
                </Grid>

                <Grid item>
                    <Checkbox
                        label="The enquiry made by an organisation or business?"
                        name="EnquiryByBusiness"
                        form={form}
                    />
                </Grid>
                {(!!form.getField('EnquiryByBusiness') && (
                    <Fragment>
                        {(!businessContact && (
                            <Grid item>
                                <ContactLookup
                                    name="Business.ID"
                                    form={form}
                                    onSelect={(_, addressBook) =>
                                        this.handleSelectBusinessContact('Business', addressBook)
                                    }
                                    onAddNewContact={addressBook =>
                                        this.handleSelectBusinessContact('Business', addressBook)
                                    }
                                />
                            </Grid>
                        )) || (
                            <Grid item>
                                <div style={{ float: 'right', marginTop: -24 }}>
                                    <Button variant="link-orange" onClick={() => form.setField({ Business: null })}>
                                        Change Supplier
                                    </Button>
                                </div>
                                <div className="container">
                                    <ContactCard
                                        variant="fullwidth" //Do no remove
                                        contact={businessContact}
                                    />
                                </div>
                            </Grid>
                        )}
                    </Fragment>
                )) || (
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <Select
                                required
                                label="Relationship to the client - their"
                                options={RelationshipToDeceasedOptions}
                                form={form}
                                name="Enquirer.RelationshipToDeceased"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Select required label="Title" options={TitleOptions} form={form} name="Enquirer.Title" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField required label="First name" form={form} name="Enquirer.FirstName" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Middle names (optional)" form={form} name="Enquirer.MiddleName" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Surname" form={form} name="Enquirer.Surname" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField required label="Primary number" form={form} name="Enquirer.PrimaryNumber" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Secondary number (optional)"
                                form={form}
                                name="Enquirer.SecondaryNumber"
                            />
                        </Grid>

                        <Grid item>
                            <TextField
                                label="Email"
                                form={form}
                                name="Enquirer.Email"
                                disabled={!!form.getField('Enquirer.NoEmailAvailable')}
                                required={!form.getField('Enquirer.NoEmailAvailable')}
                            />
                            <Checkbox label="No Email Available" form={form} name="Enquirer.NoEmailAvailable" />
                        </Grid>

                        <Grid item>
                            <Label>Enquirer's Residential Address</Label>
                            <AddressAutocomplete
                                placeholder="Search for residential address..."
                                form={form}
                                allowCustomAddress
                                name="Enquirer.ResidentialAddress"
                                componentFields={createAddressComponentFields('Enquirer.ResidentialAddress')}
                            />
                        </Grid>

                        <Grid item>
                            <Inline center>
                                <Label>Postal Address</Label>
                                <Checkbox
                                    label="Same as Enquirer's Residential Address"
                                    form={form}
                                    name="Enquirer.PostalAddressSameAsResidentialAddress"
                                />
                            </Inline>
                        </Grid>

                        <Grid item>
                            <Inline center>
                                {!form.getField('Enquirer.PostalAddressSameAsResidentialAddress') && (
                                    <AddressAutocomplete
                                        placeholder="Search for postal address..."
                                        form={form}
                                        allowCustomAddress
                                        name="Enquirer.PostalAddress"
                                        componentFields={createAddressComponentFields('Enquirer.PostalAddress')}
                                    />
                                )}
                            </Inline>
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        );
    }

    renderAuthorisedContact() {
        const { form } = this.props;

        return (
            <Grid container bucket>
                <Grid item>
                    <Inline center>
                        <div>
                            <h4>Applicant Details</h4>
                        </div>
                        <Checkbox label="Same as enquirer" form={form} name="ClientSameAsEnquirer" />
                    </Inline>
                </Grid>

                {!form.getField('ClientSameAsEnquirer') && (
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <Select label="Title" options={TitleOptions} form={form} name="Client.Title" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="First name" form={form} name="Client.FirstName" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Middle names (optional)" form={form} name="Client.MiddleName" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Surname" form={form} name="Client.Surname" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Primary number" form={form} name="Client.PrimaryNumber" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Secondary number (optional)" form={form} name="Client.SecondaryNumber" />
                        </Grid>

                        <Grid item>
                            <TextField label="Email" form={form} name="Client.Email" />
                            <Checkbox label="No Email Available" form={form} name="Client.NoEmailAvailable" />
                        </Grid>

                        <Grid item>
                            <Label>Applicant's Residential Address</Label>
                            <AddressAutocomplete
                                placeholder="Search for residential address..."
                                form={form}
                                allowCustomAddress
                                name="Client.ResidentialAddress"
                                componentFields={createAddressComponentFields('Client.ResidentialAddress')}
                            />
                        </Grid>

                        <Grid item>
                            <Inline center>
                                <Label>Postal Address</Label>
                                <Checkbox
                                    label="Same as Applicant's Residential Address"
                                    form={form}
                                    name="Client.PostalAddressSameAsResidentialAddress"
                                />
                            </Inline>
                            <Inline center>
                                {!form.getField('Client.PostalAddressSameAsResidentialAddress') && (
                                    <AddressAutocomplete
                                        placeholder="Search for postal address..."
                                        form={form}
                                        allowCustomAddress
                                        name="Client.PostalAddress"
                                        componentFields={createAddressComponentFields('Client.PostalAddress')}
                                    />
                                )}
                            </Inline>
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        );
    }

    renderRequestedOnBehalfOf() {
        const { form } = this.props;

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Deceased Details</h4>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField label="First name" name="Deceased.FirstName" form={form} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField label="Middle names (optional)" name="Deceased.MiddleName" form={form} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField label="Surname" name="Deceased.Surname" form={form} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Select label="Gender" options={GenderOptions} name="Deceased.Gender" form={form} />
                </Grid>

                <Grid item>
                    <Label>Residential Address</Label>
                    <AddressAutocomplete
                        placeholder="Search for residential address..."
                        form={form}
                        allowCustomAddress
                        name="Deceased.ResidentialAddress"
                        componentFields={createAddressComponentFields('Deceased.ResidentialAddress')}
                    />
                </Grid>

                <Grid item>
                    <Label>Date of Birth</Label>
                </Grid>

                {!form.getField('Deceased.DateOfBirthUnknown') && (
                    <Grid item xs={12} sm={6}>
                        <TextField type="date" notFuture name="Deceased.DateOfBirth" form={form} />
                    </Grid>
                )}

                <Grid item xs={12} sm={6}>
                    <Checkbox label="DOB Unknown" name="Deceased.DateOfBirthUnknown" form={form} />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Button variant="primary" onClick={e => this.openSearchModal(form)}>
                        <SearchIcon />
                        <span>Prefill from existing funeral...</span>
                    </Button>
                </Grid>

                <Grid item>
                    <Label>Current Situation</Label>
                    <Select name="Deceased.Situation" options={CurrentSituation} form={form} />
                </Grid>

                {form.getField('Deceased.Situation') === 'Deceased' && (
                    <Fragment>
                        <Grid item>
                            <Label>Date of Death</Label>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Select
                                options={DeathTimingOptions}
                                name="Deceased.DateOfDeathTiming"
                                form={form}
                                required={form.getField('Deceased.Situation') === 'Deceased'}
                            />
                        </Grid>

                        {form.getField('Deceased.DateOfDeathTiming') !== DeathTimingOption.UNKNOWN.value &&
                            (form.getField('Deceased.DateOfDeathTiming') === DeathTimingOption.BETWEEN.value ? (
                                <Fragment>
                                    <Grid item xs={6} sm={4}>
                                        <TextField
                                            name="Deceased.DateOfDeath1"
                                            type="date"
                                            notFuture
                                            form={form}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4}>
                                        <TextField
                                            name="Deceased.DateOfDeath2"
                                            type="date"
                                            notFuture
                                            form={form}
                                            required
                                        />
                                    </Grid>
                                </Fragment>
                            ) : (
                                <Grid item xs={6} sm={5} lg={5}>
                                    <TextField
                                        name="Deceased.DateOfDeath1"
                                        type="date"
                                        notFuture
                                        form={form}
                                        required
                                    />
                                </Grid>
                            ))}

                        <Grid item>
                            <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                                <Inline center>
                                    <Label>Place of Death</Label>
                                    <Checkbox
                                        label="Same as residential address"
                                        name="Deceased.PlaceOfDeathUseResidentialAddress"
                                        form={form}
                                    />
                                </Inline>
                                {/*<a variant="link-orange">Add new</a>*/}
                            </Inline>
                            {!form.getField('Deceased.PlaceOfDeathUseResidentialAddress') && (
                                <AddressAutocomplete
                                    placeholder="Search for place of death..."
                                    form={form}
                                    allowCustomAddress
                                    name="Deceased.PlaceOfDeath"
                                    componentFields={createAddressComponentFields('Deceased.PlaceOfDeath')}
                                />
                            )}
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        );
    }

    renderLeadSource() {
        const { form } = this.props;
        const options = LEAD_SOURCES;
        const selectedVal = form.getField('LeadSource.SourceType');
        const selectedOpt = !!selectedVal && options.find(opt => opt.value === selectedVal);
        const selectedText = !!selectedOpt && selectedOpt.which;
        return (
            <>
                <Grid item md={6} xs={12}>
                    <AutoComplete
                        label="Source of The Lead"
                        placeholder="Select a source type..."
                        options={options}
                        form={form}
                        name="LeadSource.SourceType"
                        limit={15}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextField label={selectedText || 'Source Name'} form={form} name="LeadSource.SourceName" />
                </Grid>
            </>
        );
    }

    renderRightColumn() {
        const { form } = this.props;

        return (
            <Fragment>
                {form.getField('EnquiryType') === 'Plaque' && this.renderPlaqueLocation()}

                {1 === 2 && this.renderQuotes()}
                {1 === 2 && this.renderArrangementAppointment()}
                {1 === 2 && this.renderAssociatedOrders()}

                {form.getField('EnquiryType') === 'Cremation' && this.renderCremationDetails()}
                {form.getField('EnquiryType') === 'Plaque' && this.renderAshLocation()}
                {form.getField('ID') &&
                    (form.getField('EnquiryType') === 'Cremation' || form.getField('EnquiryType') === 'Plaque') &&
                    this.renderRelatedRecords()}
                {this.renderEnquiryNotes()}
            </Fragment>
        );
    }

    renderPlaqueLocation() {
        const { form } = this.props;
        const location = form.getField('PlaqueLocation');

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Plaque Location</h4>
                </Grid>
                {(!location && (
                    <Grid item>
                        <ContactLookup
                            name="PlaqueLocation.ID"
                            form={form}
                            onSelect={(_, addressBook) =>
                                this.handleSelectBusinessContact('PlaqueLocation', addressBook)
                            }
                            onAddNewContact={addressBook =>
                                this.handleSelectBusinessContact('PlaqueLocation', addressBook)
                            }
                        />
                    </Grid>
                )) || (
                    <Grid item>
                        <div style={{ float: 'right', marginTop: -24 }}>
                            <Button variant="link-orange" onClick={() => form.setField({ PlaqueLocation: null })}>
                                Change Location
                            </Button>
                        </div>
                        <div className="container">
                            <ContactCard
                                variant="fullwidth" //Do no remove
                                contact={location}
                            />
                        </div>
                    </Grid>
                )}
            </Grid>
        );
    }

    renderQuotes() {
        const { form } = this.props;
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Quotes</h4>
                </Grid>

                {!Number(form.getField('ID')) && (
                    <Grid item>
                        <p>Quotes can be added after the enquiry is saved.</p>
                    </Grid>
                )}

                {!!Number(form.getField('ID')) ? (
                    <Query
                        query={readEnquiryQuotes}
                        variables={{ id: form.getField('ID') }}
                        fetchPolicy="cache-and-network"
                        notifyOnNetworkStatusChange
                    >
                        {({ loading, data, error, refetch, networkStatus }) => {
                            this.refetchQuotes = refetch;

                            if (!!loading && (!data || networkStatus === 1))
                                return (
                                    <Grid item>
                                        <Spinner /> Loading quotes...
                                    </Grid>
                                );
                            if (!!error)
                                return (
                                    <Grid item>
                                        <AlertBar variant="error">Error loading quotes.</AlertBar>
                                    </Grid>
                                );
                            const items = (data && data.readCMQuotes && data.readCMQuotes.edges.map(e => e.node)) || [];
                            return (
                                <Fragment>
                                    {!!items && items.length > 0 && (
                                        <Grid item>
                                            <div style={{ position: 'relative' }}>
                                                {networkStatus !== 7 && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            bottom: 0,
                                                            left: 0,
                                                            right: 0,
                                                            opacity: 0.5,
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        <Spinner />
                                                    </div>
                                                )}
                                                <Table>
                                                    <HeaderRow pad>
                                                        {quoteColumns.map(column => (
                                                            <Cell key={column.label}>{column.label}</Cell>
                                                        ))}
                                                    </HeaderRow>
                                                    {items.map((row, index) => {
                                                        return (
                                                            <Row pad key={row.ID}>
                                                                {quoteColumns.map(column => {
                                                                    return (
                                                                        <Cell
                                                                            key={column.label}
                                                                            dataLabel={column.label}
                                                                        >
                                                                            {column.renderCell(row, this, index)}
                                                                        </Cell>
                                                                    );
                                                                })}
                                                            </Row>
                                                        );
                                                    })}
                                                </Table>
                                            </div>
                                        </Grid>
                                    )}

                                    <Grid item>
                                        <Inline>
                                            {!!items && !items.find(e => e.Accepted) && (
                                                <Button variant="primary" onClick={() => this.onClickAddQuote(refetch)}>
                                                    Add {items.length ? 'another' : 'a'} quote...
                                                </Button>
                                            )}
                                        </Inline>
                                    </Grid>
                                </Fragment>
                            );
                        }}
                    </Query>
                ) : (
                    <Grid item>
                        <Inline>
                            <Button variant="primary" disabled>
                                + Add a quote
                            </Button>
                        </Inline>
                    </Grid>
                )}
            </Grid>
        );
    }

    renderArrangementAppointment() {
        const { form } = this.props;
        const items = form.getField('Appointments');
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Appointments</h4>
                </Grid>
                {!Number(form.getField('ID')) && (
                    <Grid item>
                        <p>Appointments can be added after the enquiry is saved.</p>
                    </Grid>
                )}

                {!!items && items.length > 0 && (
                    <Grid item>
                        <Table>
                            <HeaderRow pad>
                                {appointmentColumns.map(column => (
                                    <Cell key={column.label}>{column.label}</Cell>
                                ))}
                            </HeaderRow>
                            {items.map((row, index) => {
                                return (
                                    <Row pad key={row.ID}>
                                        {appointmentColumns.map(column => {
                                            return (
                                                <Cell key={column.label} dataLabel={column.label}>
                                                    {column.renderCell(row, this, index)}
                                                </Cell>
                                            );
                                        })}
                                    </Row>
                                );
                            })}
                        </Table>
                    </Grid>
                )}

                <Grid item>
                    <Inline>
                        <Button
                            disabled={!Number(form.getField('ID'))}
                            variant="primary"
                            onClick={() => this.handleShowAppointmentModal()}
                        >
                            Add Appointment...
                        </Button>
                        <Button variant="secondary" href="/calendar/" target="_blank">
                            View Calendar
                        </Button>
                    </Inline>
                </Grid>
            </Grid>
        );
    }

    renderAssociatedOrders() {
        const { form } = this.props;
        return <AssociatedOrders parentType="CMEnquiry" parentID={form.getField('ID')} />;
    }

    renderCremationDetails() {
        const { form } = this.props;
        const enquiryByBusiness = form.getField('EnquiryByBusiness');

        return (
            <Fragment>
                <Grid container bucket>
                    <Grid item>
                        <h4>Booking Details</h4>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Arrival Date" type="date" form={form} name="CremationDate" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Arrival Time" type="time" form={form} name="CremationTime" />
                    </Grid>
                    {enquiryByBusiness && (
                        <Fragment>
                            <Grid item xs={12} sm={6}>
                                <PickupOrDeliveryField form={form}/>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Checkbox label="Request for Certificate of Contents" form={form} name="RequestsCertificateOfContents"/>
                            </Grid>
                        </Fragment>
                    )}
                    <Grid item xs={12} sm={6}>
                        <Checkbox label="Same-day Cremation" form={form} name="SameDayCremation"
                                helperText="As required by customer." />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Checkbox label="Priority Cremation" form={form} name="NextDayCremation"
                                helperText="As required by staff." />
                    </Grid>
                </Grid>

                <Pickup form={form}/>

                <Dispatch form={form}/>
            </Fragment>
        );
    }

    renderAshLocation() {
        const { form } = this.props;
        const ashLocations = form.getState('AshLocations') || [];
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Transfer of Ashes</h4>
                </Grid>

                {ashLocations.length > 0 &&
                    ashLocations.map((ashLocation, index) => (
                        <Grid item key={ashLocation.ID}>
                            <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                                <p>{ashLocation.Location}</p>
                                <IconButton
                                    className="icon"
                                    onClick={() => this.handleShowAshLocationHistoryModal(index)} size="large">
                                    <EditIcon />
                                </IconButton>
                                <IconButton
                                    className="icon"
                                    onClick={() => this.handleShowDeleteAshLocationAlertModal()} size="large">
                                    <DeleteIcon />
                                </IconButton>
                                {/*<IconButton className="icon" onClick={() => this.handleDeleteAshLocationHistory(index)} size="large"><DeleteIcon /></IconButton>*/}
                            </Inline>
                        </Grid>
                    ))}

                <Grid item>
                    <Button variant="primary" onClick={() => this.handleShowAshLocationHistoryModal()}>
                        Add Transfer of Ashes...
                    </Button>
                </Grid>
            </Grid>
        );
    }

    renderRelatedRecords() {
        const { form, context } = this.props;
        const { generatingRelatedRecord, generatedRelatedRecord } = this.state;

        let canHaveCremationOrder = false;
        let canHavePlaqueOrder = false;
        let relatedRecord = null;
        let canHaveRelatedRecord;
        let relatedRecordType = null;
        let relatedRecordListLink = null;

        if (
            form.getField('EnquiryType') === 'Cremation' &&
            form.getField('Deceased.Situation') ===
            'Deceased' /* &&
            !!form.getField('Quotes') &&
            !!form.getField('Quotes').find(e => e.Accepted)*/
        ) {
            canHaveCremationOrder = true;
            relatedRecordType = 'Cremation';
            relatedRecordListLink = PAGE_CREMATIONS;
            relatedRecord = form.getField('CremationOrder') || generatedRelatedRecord;
        }

        if (
            form.getField('EnquiryType') === 'Plaque' &&
            form.getField('Deceased.Situation') ===
            'Deceased' /* &&
            !!form.getField('Quotes') &&
            !!form.getField('Quotes').find(e => e.Accepted)*/
        ) {
            canHavePlaqueOrder = true;
            relatedRecordType = 'Plaque';
            relatedRecordListLink = PAGE_PLAQUES;
            relatedRecord = form.getField('PlaqueOrder') || generatedRelatedRecord;
        }

        canHaveRelatedRecord = canHaveCremationOrder || canHavePlaqueOrder;

        if (canHaveRelatedRecord) {
            return (
                <Grid container bucket>
                    <Grid item>
                        <h4>Related Records</h4>
                    </Grid>

                    {(relatedRecord && Number(relatedRecord.ID) > 0 && (
                        <Grid item>
                            <Button
                                icon={'Plaque' === relatedRecordType ? <PlaqueSignIcon /> : <UrnIcon />}
                                variant="urgent"
                                onClick={() => context.props.history.push(relatedRecordListLink + relatedRecord.LegacyKey + '/' + relatedRecord.ID)}
                            >
                                View {relatedRecordType} {relatedRecord.LegacyKey}
                            </Button>
                        </Grid>
                    )) || (
                        <Grid item>
                            <Button
                                variant="confirmation"
                                disabled={generatingRelatedRecord || form.isDirty}
                                onClick={() => this.generateRelatedRecord(relatedRecordType)}
                                icon={!generatingRelatedRecord ? <UrnIcon /> : <Spinner />}
                            >
                                {!generatingRelatedRecord ? (
                                    'Generate ' + relatedRecordType + ' Record'
                                ) : (
                                    <Fragment>
                                        Generating {relatedRecordType}...
                                    </Fragment>
                                )}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            );
        }

        return null;
    }

    generateRelatedRecord(relatedRecordType) {
        const { form } = this.props;

        const recordFieldName = relatedRecordType + 'Order';
        const canCreateRelatedRecord =
            form.getField('Deceased.Situation') === 'Deceased' &&
            // form.getField('Quotes') &&
            // form.getField('Quotes').find(e => !!e.Accepted) &&
            !(form.getField(recordFieldName) && form.getField(recordFieldName).ID !== '0');

        if (!canCreateRelatedRecord) {
            return Promise.resolve(false);
        }

        const me = this;
        me.setState({ generatingRelatedRecord: true });

        if (relatedRecordType === 'Cremation') {
            return createCremationAsync(form).then(
                ({ data }) => {
                    if (data.createCremationOrder) {
                        me.setState({
                            generatingRelatedRecord: false,
                            generatedRelatedRecord: data.createCremationOrder
                        });
                    }
                },
                e => this.handleMutateError(e)
            );
        } else if (relatedRecordType === 'Plaque') {
            return createPlaqueAsync(form).then(
                ({ data }) => {
                    if (data.createPlaqueOrder) {
                        me.setState({
                            generatingRelatedRecord: false,
                            generatedRelatedRecord: data.createPlaqueOrder
                        });
                    }
                },
                e => this.handleMutateError(e)
            );
        }
    }

    renderEnquiryNotes() {
        const { form } = this.props;

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Booking Notes</h4>
                </Grid>

                <Grid item>
                    <TextField button={{ children: '+ Add Notes' }} multiline placeholder="Notes are written here..."
                               name="Notes" form={form} />
                </Grid>

                {form.getField('OldNotes') && (
                    <Grid item>
                        <NotesReadOnly name="OldNotes" form={form} />
                    </Grid>
                )}
            </Grid>
        );
    }

    onClickViewQuote(index) {
        this.setState({
            quoteModal: {
                open: true,
                quoteIndex: index
            }
        });
    }

    onClickViewAppointment(id) {
        this.setState({ showAppointmentModal: true, appointmentId: id });
    }

    onClickAddQuote() {
        this.setState({
            quoteModal: {
                open: true,
                quoteIndex: null
            }
        });
    }

    handleCloseQuoteModal(refetch = false) {
        this.setState({
            quoteModal: {
                open: false,
                quoteIndex: null
            }
        });
        if (!!this.refetchQuotes && !!refetch)
            this.refetchQuotes().then(({ data }) => {
                const { form } = this.props;
                const Quotes = deleteTypeName(cloneDeep(data.readCMQuotes.edges.map(e => e.node)));
                form.setState({ Quotes });
            });
    }

    handleShowAppointmentModal() {
        this.setState({ showAppointmentModal: true, appointmentId: null });
    }

    handleCloseAppointmentModal() {
        this.setState({ showAppointmentModal: false, appointmentId: null });
    }

    handleShowAshLocationHistoryModal(index) {
        this.setState({ editAshLocationHistoryIndex: index });
        this.setState({ showAshLocationHistoryModal: true });
    }

    handleCloseAshLocationHistoryModal() {
        this.setState({ showAshLocationHistoryModal: false });
    }

    handleSaveAshLocationHistoryModal(ashLocation) {
        const { form } = this.props;
        const { editAshLocationHistoryIndex } = this.state;
        const AshLocations = form.getState('AshLocations') || [];

        if (
            editAshLocationHistoryIndex !== null &&
            editAshLocationHistoryIndex !== undefined &&
            AshLocations[editAshLocationHistoryIndex]
        ) {
            const existingAshLocationHistory = AshLocations[editAshLocationHistoryIndex];
            Object.assign(existingAshLocationHistory, ashLocation);
        } else {
            AshLocations.push(ashLocation);
        }
        this.setState({ showAshLocationHistoryModal: false });
        this.setState({ editAshLocationHistoryIndex: null });

        form.setState({ AshLocations });
        form.save();
    }

    handleDeleteAshLocationHistory(index) {
        const { form } = this.props;
        const AshLocations = form.getState('AshLocations') || [];

        if (index !== -1) {
            AshLocations.splice(index, 1);
            form.setState({ AshLocations });
        }
    }

    openSearchModal(form) {
        let searchModalSuggestion = joinDefined(
            [
                form.getField('Deceased.FirstName'),
                form.getField('Deceased.MiddleName'),
                form.getField('Deceased.Surname')
            ],
            ' '
        );
        this.setState({ openSearchModal: true, searchModalSuggestion });
    }

    copyDetailsFromFuneral(e, form) {
        if (!isNullOrUndefined(e)) {
            const state = copyFuneral(e);
            form.setField(state);
        }
        this.setState({ openSearchModal: false, searchModalSuggestion: null });
    }
}

export const quoteColumns = [
    {
        label: 'Quote',
        renderCell: (row, context, index) => {
            return (
                <Button variant="link-orange" onClick={() => context.onClickViewQuote(index)}>
                    #{row.ID}
                </Button>
            );
        }
    },
    {
        label: 'Type',
        renderCell: row => {
            return <span>{row.QuoteType}</span>;
        }
    },
    {
        label: 'Status',
        renderCell: row => (
            <span>
                {row.Accepted ? 'Accepted' : row.RespondedDate ? 'Declined' : row.Released ? 'Released' : 'Draft'}
            </span>
        )
    },
    {
        label: 'Created',
        renderCell: row => <span>{moment(row.Created).format('D/MM/YYYY h:mma')}</span>
    },
    {
        label: 'Amount',
        renderCell: row => <span>{prettyPrice(row.CalcQuoteTotal)}</span>
    },
    {
        label: 'Accepted',
        renderCell: row => {
            return row.Accepted ? <TickIcon /> : '';
        }
    }
];

export default {
    id: 'Enquiry',
    label: 'Booking',
    component: withStyles({})(Enquiry),
    fragment: EnquiryFragment,
    onLoad: data => {
        // create a stub to detect new notes on save!
        if (!!data.Notes) {
            data.OldNotes = '' + (data.Notes || '');
        }
        data.Notes = null;
    },
    formatSaveData: (saveData, state) => {
        if (isContactDefined(saveData.Business)) {
            saveData.BusinessID = state.Business.ID;
            delete saveData.Business;
        } else if (saveData.Business === null) {
            saveData.BusinessID = null;
            delete saveData.Business;
        }

        if (isContactDefined(saveData.PlaqueLocation)) {
            saveData.PlaqueLocationID = state.PlaqueLocation.ID;
            delete saveData.PlaqueLocation;
        } else if (saveData.PlaqueLocation === null) {
            saveData.PlaqueLocationID = null;
            delete saveData.PlaqueLocation;
        }
        delete saveData.Quotes;
        delete saveData.Appointments;
        delete saveData.AssociatedOrders;
    }
};
